var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrap-content-mobile" }, [
    _c("div", { staticClass: "header-view" }, [
      _c("i", { staticClass: "fa fa-bars", on: { click: _vm.toggleSidebar } }),
      _vm._v(" "),
      _c("div", { staticClass: "title-app" }, [
        _vm._v(_vm._s(_vm.application_detail.name))
      ])
    ]),
    _vm._v(" "),
    _vm.isShowSidebar
      ? _c("div", {
          staticClass: "bg-blur-sidebar",
          attrs: { id: "bg-blur-sidebar" },
          on: { click: _vm.toggleSidebar }
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.isShowSidebar
      ? _c(
          "div",
          { staticClass: "sidebar-mobile", attrs: { id: "sidebar-mobile" } },
          [
            _c("div", { staticClass: "left-sidebar" }, [
              _c("img", {
                attrs: {
                  src: require("@/assets/app-manager/icon/more-app.svg"),
                  width: "25",
                  height: "25"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex flex-column align-items-center" },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "profile-pic",
                    attrs: {
                      src:
                        _vm.profile_data.photo_url ||
                        require("@/assets/img/profile-dummy.png")
                    }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "wrap-page" }, [
              _c(
                "div",
                { staticClass: "d-flex flex-column align-items-center" },
                [
                  _c("img", {
                    staticClass: "app-icon",
                    attrs: { src: _vm.application_detail.icon }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "app-name" }, [
                    _vm._v(_vm._s(_vm.application_detail.name))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "ul",
                _vm._l(_vm.listPages, function(page) {
                  return _c("li", { key: page.id }, [
                    _c(
                      "div",
                      {
                        staticClass: "page",
                        class: {
                          active:
                            _vm.pageSelected && _vm.pageSelected.id === page.id
                        },
                        on: {
                          click: function($event) {
                            _vm.$emit("selected-page", page)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "d-flex align-items-start" }, [
                          _c("img", {
                            staticClass: "page-icon",
                            attrs: {
                              src:
                                _vm.pageSelected &&
                                _vm.pageSelected.id === page.id
                                  ? page.icon_active
                                  : page.icon_white
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "page-name" }, [
                            _vm._v(_vm._s(page.name))
                          ])
                        ]),
                        _vm._v(" "),
                        page.child && page.type === "menu"
                          ? _c("i", {
                              staticClass: "fa fa-chevron-down dropdown-icon"
                            })
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    page.child.length > 0
                      ? _c(
                          "ul",
                          _vm._l(page.child, function(child) {
                            return _c("li", { key: child.id }, [
                              _c(
                                "div",
                                {
                                  staticClass: "page page-child",
                                  class: {
                                    active:
                                      _vm.pageSelected &&
                                      _vm.pageSelected.id === child.id
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.$emit("selected-page", child)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex align-items-start" },
                                    [
                                      _c("img", {
                                        staticClass: "page-icon",
                                        attrs: {
                                          src:
                                            _vm.pageSelected &&
                                            _vm.pageSelected.id === child.id
                                              ? child.icon_active
                                              : child.icon_white
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "page-name" }, [
                                        _vm._v(_vm._s(child.name))
                                      ])
                                    ]
                                  )
                                ]
                              )
                            ])
                          })
                        )
                      : _vm._e()
                  ])
                })
              )
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "dummy-notification" }, [
      _c("i", { staticClass: "fa fa-bell bell-icon" }),
      _vm._v(" "),
      _c("div", { staticClass: "dot-notification" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e4624b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e4624b0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/application-manager/detail/app-tabs/partials/jLayoutTabMobile.vue
// module id = null
// module chunks = 